import { useMemo } from 'react';
import { useQuery } from '@tanstack/react-query';
import { BaseAPI, Configuration } from '@rbx/clients-core';
import { getBEDEV2ServiceBasePathV2 } from '../utils/getBasePaths';
import useNavigationConfigs from '../hooks/useNavigationConfigs';

export type TFooterBehavior = {
  showGermanyOnlyLink: boolean;
  settingsLink?: string;
  youTubeLink?: string;
};

// ! NOTE(@zwang, 01/28/25): this is a VERY special case where a client cannot be accurately
// ! generated by its swagger schema, DO NOT copy this pattern unless you know what you are doing
class GUACClient extends BaseAPI {
  constructor(basePath: string) {
    const configuration = new Configuration({
      basePath,
      credentials: 'include',
    });

    super(configuration);
  }

  async loadBehavior<T>(behavior: string): Promise<T> {
    return this.request({
      path: `/v1/bundles/${behavior}`,
      method: 'GET',
      headers: {},
    }).then((response) => response.json() as Promise<T>);
  }
}

const useLoadFooterBehavior = () => {
  const { target, robloxEnvironment: environment } = useNavigationConfigs();
  const guacApi = useMemo(() => {
    const basePath = getBEDEV2ServiceBasePathV2('guac-v2', target, environment);

    return new GUACClient(basePath);
  }, [environment, target]);

  return useQuery({
    queryKey: ['guac', 'loadBehavior'],
    queryFn: () => {
      return guacApi.loadBehavior<TFooterBehavior>('creator-hub-footer-link');
    },
  });
};

export default useLoadFooterBehavior;
